import React from 'react';
import Icon from '../../../components/AppIcon';

const WorkflowStats = ({ stats }) => {
  const statCards = [
    {
      label: 'قيد المراجعة',
      value: stats?.pendingReview,
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
    },
    {
      label: 'يتطلب موافقتك',
      value: stats?.requiresYourApproval,
      icon: 'AlertCircle',
      color: 'text-error',
      bgColor: 'bg-error/10',
    },
    {
      label: 'موافق عليه',
      value: stats?.approved,
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10',
    },
    {
      label: 'مرفوض',
      value: stats?.rejected,
      icon: 'XCircle',
      color: 'text-error',
      bgColor: 'bg-error/10',
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-2 mb-3">
      {statCards?.map((stat, index) => (
        <div key={index} className="bg-card border border-border rounded-md p-2">
          <div className={`w-7 h-7 rounded-md ${stat?.bgColor} flex items-center justify-center mb-1.5`}>
            <Icon name={stat?.icon} size={14} className={stat?.color} />
          </div>
          <p className="text-[10px] text-muted-foreground mb-0.5">{stat?.label}</p>
          <p className="text-base md:text-lg font-bold text-foreground font-data">{stat?.value}</p>
        </div>
      ))}
    </div>
  );
};

export default WorkflowStats;